import React from 'react';
import AnimatedSection from './AnimatedSection';
import './SharedStyles.css';
import './Contacts.css';

const Contacts = () => {
  return (
    <AnimatedSection direction="fade" className="contacts-section" delay={150} id="contacts">
      <div className="section-content-wrapper">
        <h2 className="section-title">
          <span className="title-accent">Get</span> in touch
        </h2>
        <div className="content-card">
          <div className="contact-icon">📧</div>
          <p className="contact-label">Corporate email address</p>
          <a 
            href="mailto:glebburavlevbg5@bg5gamescom.net" 
            className="contact-email"
          >
            <span className="email-text">glebburavlevbg5@bg5gamescom.net</span>
            <span className="email-icon">→</span>
          </a>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default Contacts;
